import {Actions} from "Kyc/action";

export interface IState {
    invoker: string;
    completed: boolean;
    productCode: string;
}
const defaultState: IState = {
    invoker: null,
    completed: false,
    productCode: null,
};

export default function kyc(state = defaultState, action) {

    switch (action.type) {
        case Actions.SET_KYC_INVOKER:
            return{
                ...state,
                invoker: action.body,
            };
        case Actions.SET_KYC_COMPLETED:
            return{
                ...state,
                completed: action.body,
            };
        case Actions.SET_PRODUCT_CODE:
            return{
                ...state,
                productCode: action.body,
            };
        case Actions.CLEAR_KYC_STATE:
            return defaultState;
        default:
            return state;
    }
}
